//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "payment-detail",
  data(){
    return{
      paymentId:null,
      paymentObj:{}
    }
  },
  methods:{
    getPayment(){
      this.$loadingShow();
      this.$get(`api/payment/${this.paymentId}`).then((res) => {
        this.paymentObj = res;
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    }
  },
  mounted(){
    this.paymentId = this.$route.params.id;
    this.getPayment();
  }
}



// WEBPACK FOOTER //
// ./src/page/procu-syner/payment-detail.vue